﻿<template>
  <div
    v-if="contentModel !== null || vueModelData !== null"
    id="quickquote-health-step-1-component"
    data-test="quickquote-health-step-1"
  >
    <!-- Sundhedsforsikring -->
    <h1-and-tooltip
      :h1="contentModel.SharedFields.LabelHeadingStep1"
      :tooltip="contentModel.TooltipStep1HealthInsurance"
    />
    <section>
      <!-- Hvem ønsker du at forsikre -->
      <article class="flow-group">
        <div class="control">
          <fieldset>
            <div class="row">
              <div class="small-12 columns">
                <legend>
                  <h3-and-tooltip
                    data-test="quickquote-health-who-will-be-insured"
                    :h3="contentModel.LabelWhoWillBeInsured"
                    :tooltip="contentModel.TooltipWhoWillBeInsured"
                  />
                </legend>
              </div>
            </div>
            <div class="row">
              <div class="small-12 medium-6 columns radio-stacked">
                <Field
                  id="WhoWillBeInsuredSelf"
                  :model-value="vueModelData.TemplateModel.Insured"
                  @update:model-value="setInsured"
                  :rules="'required'"
                  type="radio"
                  name="Insured"
                  value="self"
                  data-test="quickquote-health-input-who-will-be-insured-self"
                />
                <LabelAndTooltip
                  for="WhoWillBeInsuredSelf"
                  :label="contentModel.LabelRadioButtonMyself"
                  :tooltip="contentModel.TooltipRadioButtonMyself"
                />
                <Field
                  id="WhoWillBeInsuredChild"
                  :model-value="vueModelData.TemplateModel.Insured"
                  @update:model-value="setInsured"
                  type="radio"
                  name="Insured"
                  value="child"
                  data-test="quickquote-health-input-who-will-be-insured-child"
                />
                <LabelAndTooltip
                  for="WhoWillBeInsuredChild"
                  :label="contentModel.LabelRadioButtonMyChild"
                  :tooltip="contentModel.TooltipRadioButtonMyChild"
                />
              </div>
            </div>
            <ValidationError
              name="Insured"
              :overrides="{ required: contentModel.ValidationWhoWillBeInsured }"
              data-test="quickquote-health-validation-who-will-be-insured"
            />
          </fieldset>
        </div>

        <!-- VOKSEN -->
        <div v-show="showUnderSixty" key="self">
          <!-- Er du under 60 år gammel -->
          <div
            key="self-div-control"
            class="control"
            data-test="quickquote-health-div-is-under-sixty-years-old"
          >
            <div class="row">
              <div class="small-12 columns">
                <h3-and-tooltip
                  id="UnderSixtyH3"
                  data-test="quickquote-health-h3-is-under-sixty-years-old"
                  :h3="contentModel.LabelUnderSixtyYearsOld"
                  :tooltip="contentModel.TooltipUnderSixtyYearsOld"
                />
              </div>
            </div>
            <div class="row" role="radiogroup" aria-labelledby="UnderSixtyH3Span">
              <div class="small-6 medium-3 columns radio-stacked">
                <Field
                  id="UnderSixtyYearsOldTrue"
                  key="input-is-sixty-years-old-yes"
                  v-model="isUnderSixtyYearsOld"
                  :rules="{ required: showUnderSixty }"
                  type="radio"
                  name="UnderSixtyYearsOld"
                  :value="true"
                  data-test="quickquote-health-input-is-under-sixty-years-old-true"
                />
                <label key="label-is-under-sixty-years-old-true" for="UnderSixtyYearsOldTrue">
                  {{ contentModel.SharedContent.LabelYes }}
                </label>
              </div>
              <div class="small-6 medium-3 columns radio-stacked">
                <Field
                  id="UnderSixtyYearsOldFalse"
                  key="input-is-sixty-years-old-no"
                  v-model="isUnderSixtyYearsOld"
                  type="radio"
                  name="UnderSixtyYearsOld"
                  :value="false"
                  data-test="quickquote-health-input-is-under-sixty-years-old-false"
                />
                <label key="label-is-under-sixty-years-old-false" for="UnderSixtyYearsOldFalse">
                  {{ contentModel.SharedContent.LabelNo }}
                </label>
              </div>
            </div>
            <ValidationError
              key="error-is-under-sixty-years-old"
              name="UnderSixtyYearsOld"
              :overrides="{ required: contentModel.ValidationUnderSixtyYearsOld }"
              data-test="quickquote-health-validation-is-under-sixty-years-old"
            />
          </div>
        </div>

        <!-- BARN -->
        <div v-show="showUnderTwenty" key="child">
          <!-- Er barnet under 20 år gammel -->
          <div
            key="child-div-control"
            class="control"
            data-test="quickquote-health-div-is-under-twenty-years-old"
          >
            <div class="row">
              <div class="small-12 columns">
                <h3-and-tooltip
                  id="UnderTwentyH3"
                  data-test="quickquote-health-h3-is-under-twenty-years-old"
                  :h3="contentModel.LabelUnderTwentyYearsOld"
                  :tooltip="contentModel.TooltipUnderTwentyYearsOld"
                />
              </div>
            </div>
            <div class="row" role="radiogroup" aria-labelledby="UnderTwentyH3Span">
              <div class="small-6 medium-3 columns radio-stacked">
                <Field
                  id="UnderTwentyYearsOldTrue"
                  key="input-is-under-twenty-years-old-yes"
                  v-model="isUnderTwentyYearsOld"
                  :rules="{ required: showUnderTwenty }"
                  type="radio"
                  name="UnderTwentyYearsOld"
                  :value="true"
                  data-test="quickquote-health-input-is-under-twenty-years-old-true"
                />
                <label key="label-is-under-twenty-years-old-true" for="UnderTwentyYearsOldTrue">
                  {{ contentModel.SharedContent.LabelYes }}
                </label>
              </div>
              <div class="small-6 medium-3 columns radio-stacked">
                <Field
                  id="UnderTwentyYearsOldFalse"
                  key="input-is-under-twenty-years-old-no"
                  v-model="isUnderTwentyYearsOld"
                  type="radio"
                  name="UnderTwentyYearsOld"
                  :value="false"
                  data-test="quickquote-health-input-is-under-twenty-years-old-false"
                />
                <label key="label-is-under-twenty-years-old-false" for="UnderTwentyYearsOldFalse">
                  {{ contentModel.SharedContent.LabelNo }}
                </label>
              </div>
            </div>
            <ValidationError
              key="error-is-under-twenty-years-old"
              name="UnderTwentyYearsOld"
              :overrides="{ required: contentModel.ValidationUnderTwentyYearsOld }"
              data-test="quickquote-health-validation-is-under-twenty-years-old"
            />

            <div class="row">
              <div class="small-12 columns">
                <label
                  for="firstname-child"
                  data-test="quickquote-health-label-firstname-child"
                  class="text-question"
                  v-html="contentModel.LabelTheChildsName"
                />
              </div>
            </div>
            <div class="row">
              <div class="small-12 columns">
                <Field
                  id="firstname-child"
                  v-model="vueModelData.TemplateModel.Firstname"
                  :rules="{ required: showUnderTwenty }"
                  name="firstname-child"
                  :placeholder="contentModel.PlaceholderChildFirstName"
                  :label="contentModel.LabelTheChildsName"
                  type="text"
                  data-test="quickquote-health-firstname-child-input"
                />
              </div>
              <div class="row">
                <div class="small-12 columns">
                  <ValidationError name="firstname-child" />
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- SHARED -->
        <div v-if="vueModelData.TemplateModel.Insured">
          <!-- Har du allerede en sundhedsforsikring -->
          <div class="control">
            <div class="row">
              <div class="small-12 columns">
                <questionnaire
                  :options="policyQuestions"
                  :always-show="true"
                  :heading-three="true"
                />
              </div>
            </div>
          </div>
        </div>
      </article>
    </section>

    <!-- Du skal være under 60 år - modal -->
    <transition name="modal">
      <v-modal
        :is-open="showOverSixtyYearsOldModal"
        data-test="quickquote-health-modal-self"
        @close="showOverSixtyYearsOldModal = false"
      >
        <template #title>
          <h3 v-html="contentModel.LabelOverSixtyYearsOldModalHeadline" />
        </template>
        <template #content>
          <div v-html="contentModel.TextOverSixtyYearsOldModalContent" />
        </template>
        <template #buttons>
          <div class="row">
            <div class="small-12 columns">
              <button
                class="button secondary large"
                data-test="quickquote-health-modal-self-button"
                @click="showOverSixtyYearsOldModal = false"
                v-html="contentModel.LabelOverSixtyYearsOldModalButton"
              />
            </div>
          </div>
        </template>
      </v-modal>
    </transition>

    <!-- Dit barn skal være under 20 år - modal -->
    <transition name="modal">
      <v-modal
        :is-open="showOverTwentyYearsOldModal"
        data-test="quickquote-health-modal-child"
        @close="showOverTwentyYearsOldModal = false"
      >
        <template #title>
          <h3 v-html="contentModel.LabelOverTwentyYearsOldModalHeadline" />
        </template>
        <template #content>
          <div v-html="contentModel.TextOverTwentyYearsOldModalContent" />
        </template>
        <template #buttons>
          <div class="row">
            <div class="small-12 columns">
              <button
                class="button secondary large"
                data-test="quickquote-health-modal-child-button"
                @click="showOverTwentyYearsOldModal = false"
                v-html="contentModel.LabelOverTwentyYearsOldModalButton"
              />
            </div>
          </div>
        </template>
      </v-modal>
    </transition>
  </div>
</template>

<script>
import QuickQuoteMixin from './QuickQuoteMixin.vue';
import H1AndTooltip from '@/components/UI/H1AndTooltip.vue';
import H3AndTooltip from '@/components/UI/H3AndTooltip.vue';

import ValidationError from '@/components/UI/ValidationError.vue';
import { cloneDeep } from 'lodash';
import { mapActions } from 'vuex';
import { FormContextKey } from 'vee-validate';
import { inject } from 'vue';

export default {
  name: 'HealthQuickQuote',
  components: {
    H1AndTooltip,
    H3AndTooltip,
    ValidationError
  },
  emits: ['update-personal-information', 'set-hide-next-button', 'disable-next-button'],
  setup() {
    return { form: inject(FormContextKey, undefined) };
  },
  mixins: [QuickQuoteMixin],
  beforeMount() {
    this.vueModelData = this.vueModel;
  },
  props: {
    contentModel: {
      type: Object,
      default() {
        return null;
      }
    },
    vueModel: {
      type: Object,
      default() {
        return null;
      }
    }
  },
  data() {
    return {
      showOverSixtyYearsOldModal: false,
      showOverTwentyYearsOldModal: false,
      vueModelData: null
    };
  },
  computed: {
    showUnderSixty() {
      return this.vueModelData.TemplateModel.Insured === 'self';
    },
    showUnderTwenty() {
      return this.vueModelData.TemplateModel.Insured === 'child';
    },
    isUnderSixtyYearsOld: {
      get() {
        return this.$store.state.quickQuote.isUnderSixtyYearsOld;
      },
      set(value) {
        this.$store.commit('quickQuote/setIsUnderSixtyYearsOld', value);
      }
    },
    isUnderTwentyYearsOld: {
      get() {
        return this.$store.state.quickQuote.isUnderTwentyYearsOld;
      },
      set(value) {
        this.$store.commit('quickQuote/setIsUnderTwentyYearsOld', value);
      }
    },
    defaultTemplateModel: {
      get() {
        return this.$store.state.quickQuote.defaultTemplateModel;
      },
      set(value) {
        this.$store.commit('quickQuote/setDefaultTemplateModel', value);
      }
    },
    isAlreadyInsured() {
      return this.vueModelData?.TemplateModel?.PolicyQuestionnaire?.Questionnaires[0]?.ChosenAnswer;
    },
    personalInformationForTagManager() {
      if (this.vueModelData === null) {
        return '';
      }
      return {
        event: 'track-event',
        eventCategory: this.getDanishProductTypeName + ' prisberegner',
        eventAction: '01 oplysninger submit ok',
        eventLabel: 'oplysninger submit ok',
        eventValue: '0',
        eventNoninteraction: true,
        data: {
          insured: this.vueModelData.TemplateModel.Insured
        }
      };
    }
  },
  watch: {
    isUnderSixtyYearsOld(val) {
      if (val === false) {
        this.showOverSixtyYearsOldModal = true;
        this.register({
          event: 'quickquote-health-popup-view',
          id: 'healthQuickQuote',
          vm: this.contentModel.TextOverSixtyYearsOldModalContent
        });
        this.$emit('disable-next-button', true);
      } else {
        this.$emit('disable-next-button', false);
      }
    },
    isUnderTwentyYearsOld(val) {
      if (val === false) {
        this.showOverTwentyYearsOldModal = true;
        this.register({
          event: 'quickquote-health-popup-view',
          id: 'healthQuickQuote',
          vm: this.contentModel.TextOverTwentyYearsOldModalContent
        });
        this.$emit('disable-next-button', true);
      } else {
        this.$emit('disable-next-button', false);
      }
    },
    'vueModelData.TemplateModel.Insured': function () {
      this.$emit('set-hide-next-button', false);
      if (this.showUnderSixty) {
        this.dispatchTracking('insured-adult');
      }
      if (this.showUnderTwenty) {
        this.dispatchTracking('insured-child');
      }
    },
    isAlreadyInsured(val) {
      if (val === 1000705) {
        this.dispatchTracking('not-insured');
      }
      if (val === 1000704) {
        this.dispatchTracking('already-insured');
      }
    },
    personalInformationForTagManager() {
      this.$emit('update-personal-information', this.personalInformationForTagManager);
    }
  },
  mounted() {
    if (this.vueModelData && this.vueModelData.TemplateModel) {
      if (this.vueModelData.TemplateModel.Insured === null) {
        this.$emit('set-hide-next-button', true);
        this.defaultTemplateModel = cloneDeep(this.vueModelData.TemplateModel);
      }
    }
  },
  methods: {
    setInsured(insured) {
      this.vueModelData.TemplateModel = cloneDeep(this.defaultTemplateModel);
      this.vueModelData.TemplateModel.Insured = insured;
      this.$store.dispatch('quickQuote/setIsUnderSixtyYearsOld', null);
      this.$store.dispatch('quickQuote/setIsUnderTwentyYearsOld', null);
      this.form.setErrors({});
    },
    dispatchTracking(item) {
      this.register({
        event: `quickquote-health-${item}`,
        id: 'healthQuickQuote'
      });
    },
    ...mapActions('Events', ['register'])
  }
};
</script>

<style lang="scss" scoped>
.child-name-wrapper {
  margin-bottom: 1rem;
}
</style>
